var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
// Utils
import { isObject } from '../../object';
import { getPropertiesFromObject } from '../../object/getPropertiesFromObject';
import { isEmpty } from '../../others/isEmpty';
/**
 * getArrayOfPropertyValuesFromObjectsInTheArray - gets value array from an array based on the given key string
 *
 * @param {Array<any>} array
 * @param {string[]} keysToFind - array of keys to find on target object
 *
 * @example
 * getArrayOfPropertyValuesFromObjectsInTheArray([{id: 1}], 'id');
 * // returns [1]
 * getArrayOfPropertyValuesFromObjectsInTheArray([{a: 1}, {a: {b: 2}}], 'a');
 * // returns [1, {b: 2}]
 *
 * @return {*}  {Array<any>}
 */
export var getArrayOfPropertyValuesFromObjectsInTheArray = function (array, keysToFind) { return array.reduce(function (resultArray, currentValue) {
    if (isObject(currentValue)) {
        var properties = getPropertiesFromObject(currentValue, keysToFind);
        if (!isEmpty(properties)) {
            return __spread(resultArray, [properties]);
        }
    }
    return resultArray;
}, []); };
//# sourceMappingURL=getArrayOfPropertyValuesFromObjectsInTheArray.js.map